// Mini App session token storage (STO-6: held in memory only, not localStorage)
let memoryJwtToken: string | null = null;

export function setSessionToken(token: string | null) {
  memoryJwtToken = token;
}

export function getSessionToken(): string | null {
  return memoryJwtToken;
}
export const API_ORIGIN = (
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? '' : 'https://shop-api-production.fencomshopping.workers.dev')
).replace(/\/+$/, '');
const API_BASE = `${API_ORIGIN}/v1`;

export function getMediaUrl(path?: string | null): string {
  if (!path) return '';
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:') ||
    path.startsWith('blob:')
  ) {
    return path;
  }
  let clean = path.startsWith('/') ? path : `/${path}`;
  if (clean.startsWith('/shops/')) {
    clean = `/v1/media/public${clean}`;
  } else if (clean.startsWith('/cdn/')) {
    clean = `/v1/media/public/${clean.slice(5)}`;
  }
  return `${API_ORIGIN}${clean}`;
}

export async function storeApiRequest<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const headers = new Headers(options.headers || {});
  
  if (memoryJwtToken) {
    headers.set('Authorization', `Bearer ${memoryJwtToken}`);
  }

  if (options.body && typeof options.body === 'string' && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    const message = errorData?.error?.message || `Request failed with status ${res.status}`;
    const code = errorData?.error?.code || 'INTERNAL_ERROR';
    const err = new Error(message) as any;
    err.code = code;
    err.status = res.status;
    err.details = errorData?.error?.details;
    throw err;
  }

  return res.json();
}
